import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetorajsthaninnnova() {



const cardData = {
keyword: "Pune to Rajasthan Innova Crysta Rental",
headingDescription: "Pune to Rajasthan Innova Crysta Rental provides spacious private transportation for travelers planning a long-distance journey from Pune to Rajasthan. Citysky Cabs offers comfortable Innova Crysta vehicles with air conditioning, generous seating, luggage space, and professional driver support for family holidays, group tours, corporate travel, tourist journeys, one-way travel, round trips, and extended Rajasthan itineraries.",


topPlaces: [
    {
        title: "Jaipur",
        description: "Jaipur is a major Rajasthan destination known for its forts, palaces, historic architecture, markets, and cultural attractions. Travelers from Pune can use a spacious Innova Crysta for the long road journey and convenient transfers between hotels, sightseeing locations, and other parts of the city."
    },
    {
        title: "Udaipur",
        description: "Udaipur is known for its lakes, palaces, heritage architecture, and scenic surroundings, making it a popular destination for family and tourist trips. A private Innova Crysta provides comfortable transportation for travelers carrying luggage and planning an extended Rajasthan itinerary."
    },
    {
        title: "Jodhpur",
        description: "Jodhpur is a prominent Rajasthan city recognized for Mehrangarh Fort, historic neighborhoods, markets, and distinctive blue-painted areas. Travelers can use a private Innova Crysta to reach Jodhpur comfortably and continue to nearby attractions as part of a longer Rajasthan tour."
    },
    {
        title: "Jaisalmer",
        description: "Jaisalmer is a well-known desert destination featuring the historic Jaisalmer Fort, traditional architecture, and access to desert experiences. A spacious Innova Crysta is useful for travelers undertaking the long journey from Pune and carrying luggage for a multi-day Rajasthan vacation."
    },
    {
        title: "Pushkar",
        description: "Pushkar is a popular cultural and pilgrimage destination known for Pushkar Lake, temples, and its traditional atmosphere. Families and tourists traveling from Pune can include Pushkar in their Rajasthan itinerary while enjoying private chauffeur-driven transportation."
    },
    {
        title: "Ajmer",
        description: "Ajmer is an important Rajasthan destination with religious, historical, and cultural significance. A private Innova Crysta can provide convenient transportation for travelers visiting Ajmer as part of a family tour, pilgrimage, or broader Rajasthan sightseeing journey."
    },
    {
        title: "Mount Abu",
        description: "Mount Abu is Rajasthan's well-known hill station, offering a cooler climate, scenic viewpoints, temples, and natural attractions. Travelers from Pune can use a comfortable Innova Crysta for the long-distance road journey and local transfers during their stay."
    },
    {
        title: "Bikaner",
        description: "Bikaner is a historic desert city known for forts, palaces, traditional markets, and regional culture. A spacious private vehicle is suitable for travelers planning to cover Bikaner along with other Rajasthan destinations while carrying luggage throughout their multi-city tour."
    },
    {
        title: "Ranthambore",
        description: "Ranthambore is a popular destination for wildlife and heritage tourism, with the national park and historic fort forming key attractions. Travelers can include Ranthambore in a Rajasthan road itinerary and use an Innova Crysta for comfortable transportation between destinations."
    },
    {
        title: "Chittorgarh",
        description: "Chittorgarh is an important heritage destination known for its historic fort and Rajput-era landmarks. A private Innova Crysta provides a convenient option for families and tourist groups traveling from Pune who want to include Chittorgarh in a longer Rajasthan tour."
    }
],

services: [
    {
        name: "Pune to Rajasthan Innova Crysta Cab",
        description: "Pune to Rajasthan Innova Crysta Cab provides spacious private transportation for the long-distance journey from Pune to Rajasthan. Comfortable seating, air conditioning, luggage space, and professional driver support make it suitable for families, groups, tourists, and business travelers."
    },
    {
        name: "Pune to Rajasthan Innova Crysta Taxi",
        description: "Pune to Rajasthan Innova Crysta Taxi offers dedicated chauffeur-driven transportation for travelers covering the long route to Rajasthan. The spacious seven-seater vehicle is useful for passengers carrying luggage and planning a multi-day holiday or business journey."
    },
    {
        name: "Pune Rajasthan Innova Crysta Booking",
        description: "Pune Rajasthan Innova Crysta Booking allows travelers to arrange a private vehicle according to their travel dates, passenger requirements, and planned itinerary. It is suitable for family vacations, group tours, corporate travel, sightseeing, and extended Rajasthan road trips."
    },
    {
        name: "Pune Rajasthan Innova Crysta Rental",
        description: "Pune Rajasthan Innova Crysta Rental provides a comfortable private vehicle for travelers planning an extended journey from Pune to Rajasthan. The spacious cabin and luggage capacity are practical for families, friends, tourist groups, and professionals traveling together."
    },
    {
        name: "Pune to Rajasthan Innova Crysta on Rent",
        description: "Pune to Rajasthan Innova Crysta on Rent gives passengers access to a spacious vehicle with driver support for the long-distance journey. Travelers can remain together in one vehicle while carrying suitcases, travel bags, and other belongings needed for a Rajasthan trip."
    },
    {
        name: "Pune to Rajasthan Innova Crysta Hire",
        description: "Pune to Rajasthan Innova Crysta Hire provides dedicated transportation for passengers who prefer a private chauffeur-driven vehicle. The Innova Crysta is suitable for long-distance family tours, group travel, corporate journeys, tourist itineraries, and personal trips."
    },
    {
        name: "Pune Rajasthan AC Innova Crysta Cab",
        description: "Pune Rajasthan AC Innova Crysta Cab provides a climate-controlled cabin for comfortable travel over the extended Pune to Rajasthan route. Spacious seating and useful luggage capacity make the vehicle suitable for families, groups, and travelers undertaking multi-day journeys."
    },
    {
        name: "Pune Rajasthan Luxury Innova Crysta Cab",
        description: "Pune Rajasthan Luxury Innova Crysta Cab offers a spacious and premium-feel private travel experience for long-distance passengers. Comfortable interiors, air conditioning, generous seating, and chauffeur-driven service are useful for family holidays, corporate travel, and special Rajasthan tours."
    },
    {
        name: "Pune to Rajasthan 7 Seater Innova Crysta",
        description: "Pune to Rajasthan 7 Seater Innova Crysta is suitable for families and small groups who want to travel together in one vehicle. The seven-seater arrangement provides useful passenger space while allowing travelers to carry luggage for a longer Rajasthan itinerary."
    },
    {
        name: "Pune Rajasthan One Way Innova Crysta Cab",
        description: "Pune Rajasthan One Way Innova Crysta Cab is convenient for travelers who require private transportation from Pune to Rajasthan without the same vehicle being needed for the return journey. It can suit relocation, family visits, personal travel, and one-direction tours."
    },
    {
        name: "Pune Rajasthan Round Trip Innova Crysta Cab",
        description: "Pune Rajasthan Round Trip Innova Crysta Cab is suitable for travelers planning to return to Pune after completing their Rajasthan tour. A dedicated vehicle provides convenient transportation for multi-day family holidays, sightseeing itineraries, group tours, and extended road trips."
    },
    {
        name: "Pune Rajasthan Outstation Innova Crysta",
        description: "Pune Rajasthan Outstation Innova Crysta provides spacious private transportation for the long-distance journey across states. Comfortable seating, air conditioning, luggage capacity, and driver support make it suitable for families, tourists, groups, and business travelers."
    },
    {
        name: "Pune Rajasthan Family Trip Cab",
        description: "Pune Rajasthan Family Trip Cab offers private transportation for families planning a long Rajasthan vacation. The spacious Innova Crysta allows family members to travel together while carrying suitcases, children's belongings, and other personal items needed for the extended journey."
    },
    {
        name: "Pune Rajasthan Group Travel Innova Crysta",
        description: "Pune Rajasthan Group Travel Innova Crysta is suitable for friends, relatives, colleagues, and small tourist groups traveling together. Keeping the group in one spacious vehicle makes it easier to coordinate luggage, travel schedules, sightseeing plans, and accommodation transfers."
    },
    {
        name: "Pune Rajasthan Corporate Travel Cab",
        description: "Pune Rajasthan Corporate Travel Cab provides comfortable transportation for executives, employees, clients, and business travelers visiting Rajasthan. The chauffeur-driven Innova Crysta can support meetings, corporate assignments, business visits, conferences, and intercity transfers."
    },
    {
        name: "Affordable Pune Rajasthan Innova Crysta Cab",
        description: "Affordable Pune Rajasthan Innova Crysta Cab provides a practical private travel option for passengers planning the lengthy journey from Pune to Rajasthan. Families, groups, tourists, and professionals can travel together in a spacious vehicle with driver support."
    },
    {
        name: "Pune Rajasthan Long Distance Cab",
        description: "Pune Rajasthan Long Distance Cab provides a comfortable private transportation solution for the extended interstate road journey. The Innova Crysta offers spacious seating and luggage capacity, making it suitable for travelers planning multi-day Rajasthan tours."
    },
    {
        name: "Pune Rajasthan Tourist Cab",
        description: "Pune Rajasthan Tourist Cab provides private transportation for travelers exploring Rajasthan's forts, palaces, temples, markets, heritage sites, and natural attractions. A spacious Innova Crysta is useful for multi-city sightseeing itineraries involving several destinations."
    },
    {
        name: "Pune Rajasthan Innova Crysta Taxi Service",
        description: "Pune Rajasthan Innova Crysta Taxi Service offers chauffeur-driven transportation for passengers traveling from Pune to Rajasthan. It can support family holidays, tourist tours, group travel, corporate assignments, one-way journeys, and round-trip road trips."
    },
    {
        name: "Pune Rajasthan Innova Crysta Cab Near Me",
        description: "Pune Rajasthan Innova Crysta Cab Near Me helps travelers searching for a convenient private cab option for their Rajasthan journey. A pre-arranged vehicle can be planned according to the pickup location, travel date, passenger count, luggage requirements, and itinerary."
    },
    {
        name: "Pune Rajasthan Private Cab",
        description: "Pune Rajasthan Private Cab provides dedicated transportation without unrelated passengers sharing the vehicle. Families, friends, groups, and corporate travelers can enjoy a more private environment throughout the long-distance journey from Pune to Rajasthan."
    },
    {
        name: "Pune Rajasthan Innova Crysta Cab Hire",
        description: "Pune Rajasthan Innova Crysta Cab Hire provides a spacious private vehicle with professional driver support for travelers planning a Rajasthan trip. It is suitable for family tours, group travel, corporate journeys, tourist itineraries, and long-distance personal travel."
    },
    {
        name: "Pune Rajasthan Rental Car with Driver",
        description: "Pune Rajasthan Rental Car with Driver provides a chauffeur-driven travel solution for passengers who prefer not to manage the long interstate journey themselves. The spacious Innova Crysta is suitable for families, groups, tourists, and business travelers carrying luggage."
    },
    {
        name: "Pune Rajasthan Family Tour Cab",
        description: "Pune Rajasthan Family Tour Cab provides comfortable private transportation for families planning to explore multiple Rajasthan destinations. Passengers can travel together in a spacious Innova Crysta while carrying luggage and visiting forts, palaces, temples, markets, and cultural attractions."
    },
    {
        name: "Pune Rajasthan Outstation Taxi",
        description: "Pune Rajasthan Outstation Taxi provides private chauffeur-driven transportation for travelers covering the long-distance route from Pune to Rajasthan. The service is suitable for family holidays, tourist tours, group journeys, business travel, and planned interstate road trips."
    }
],

tableData: [
    ["Pune to Rajasthan Innova Crysta Cab"],
    ["Pune to Rajasthan Innova Crysta Taxi"],
    ["Pune Rajasthan Innova Crysta Booking"],
    ["Pune Rajasthan Innova Crysta Rental"],
    ["Pune to Rajasthan Innova Crysta on Rent"],
    ["Pune to Rajasthan Innova Crysta Hire"],
    ["Pune Rajasthan AC Innova Crysta Cab"],
    ["Pune Rajasthan Luxury Innova Crysta Cab"],
    ["Pune to Rajasthan 7 Seater Innova Crysta"],
    ["Pune Rajasthan One Way Innova Crysta Cab"],
    ["Pune Rajasthan Round Trip Innova Crysta Cab"],
    ["Pune Rajasthan Outstation Innova Crysta"],
    ["Pune Rajasthan Family Trip Cab"],
    ["Pune Rajasthan Group Travel Innova Crysta"],
    ["Pune Rajasthan Corporate Travel Cab"],
    ["Affordable Pune Rajasthan Innova Crysta Cab"],
    ["Pune Rajasthan Long Distance Cab"],
    ["Pune Rajasthan Tourist Cab"],
    ["Pune Rajasthan Innova Crysta Taxi Service"],
    ["Pune Rajasthan Innova Crysta Cab Near Me"],
    ["Pune Rajasthan Private Cab"],
    ["Pune Rajasthan Innova Crysta Cab Hire"],
    ["Pune Rajasthan Rental Car with Driver"],
    ["Pune Rajasthan Family Tour Cab"],
    ["Pune Rajasthan Outstation Taxi"]
],

whychoose: [
    {
        WhyChooseheading: "Comfortable Interstate Travel",
        WhyChoosedescription: "The Innova Crysta provides a spacious cabin for the lengthy journey from Pune to Rajasthan. Comfortable seating, air conditioning, and useful luggage capacity make it practical for passengers spending extended hours on the road."
    },
    {
        WhyChooseheading: "Suitable for Multi-City Tours",
        WhyChoosedescription: "Rajasthan travel often involves visiting several cities and attractions rather than staying in one location. A private vehicle makes it easier for families and groups to organize a multi-destination itinerary while keeping their luggage with them."
    },
    {
        WhyChooseheading: "Ideal for Family Holidays",
        WhyChoosedescription: "Families can travel together in one seven-seater Innova Crysta while carrying suitcases and personal belongings for a longer vacation. Private transportation also provides convenient door-to-door movement between Pune, Rajasthan destinations, hotels, and sightseeing locations."
    },
    {
        WhyChooseheading: "Convenient Group Transportation",
        WhyChoosedescription: "Friends, relatives, and small tourist groups can remain together throughout the long road journey. One spacious vehicle helps simplify coordination of passengers, luggage, planned breaks, accommodation transfers, and sightseeing schedules."
    },
    {
        WhyChooseheading: "Professional Chauffeur Support",
        WhyChoosedescription: "A chauffeur-driven arrangement allows passengers to relax during the interstate journey rather than handling navigation, traffic, and long-distance driving themselves. This can be particularly convenient for families, tourists, and business travelers."
    },
    {
        WhyChooseheading: "One-Way and Round-Trip Flexibility",
        WhyChoosedescription: "Travel requirements vary depending on the purpose of a Rajasthan trip, so one-way and round-trip arrangements provide useful options. These can accommodate relocation, family visits, tourist holidays, business assignments, and multi-day tours."
    },
    {
        WhyChooseheading: "Spacious Luggage Capacity",
        WhyChoosedescription: "Long Rajasthan trips often involve multiple bags and personal belongings. The Innova Crysta provides useful luggage space along with comfortable passenger seating, making it practical for families and groups planning extended interstate travel."
    },
    {
        WhyChooseheading: "Useful for Business and Tourism",
        WhyChoosedescription: "The vehicle can support both professional and leisure travel requirements. Corporate travelers can use it for business visits and meetings, while families and tourists can use the same spacious transportation for sightseeing, heritage tours, and longer vacations."
    }
]


};




















const faqData = [
{
question: "Can I rent an Innova Crysta from Pune to Rajasthan?",
answer: "An Innova Crysta can be arranged for a long-distance journey from Pune to Rajasthan for families, groups, and travellers planning an extended road trip. Citysky Cabs can coordinate the rental according to your pickup location in Pune, Rajasthan destination, travel dates, passenger count, luggage, and complete itinerary."
},
{
question: "Is an Innova Crysta suitable for a long road trip from Pune to Rajasthan?",
answer: "For a multi-day road journey, an Innova Crysta can be a practical choice for passengers who prefer travelling together in one vehicle. It is particularly useful for families and small groups carrying luggage and planning to visit more than one destination during their Rajasthan trip."
},
{
question: "Can I travel from Pune to Rajasthan by Innova Crysta for a multi-city tour?",
answer: "Travellers planning a Rajasthan road trip can discuss a multi-city itinerary while arranging the Innova Crysta rental. The journey may include destinations such as Jaipur, Udaipur, Jodhpur, Jaisalmer, Ajmer, or other places depending on the group's preferred route, travel dates, and sightseeing plans."
},
{
question: "Can I book an Innova Crysta from Pune to Rajasthan for a family holiday?",
answer: "Families can consider an Innova Crysta for an extended Rajasthan holiday involving multiple cities and sightseeing stops. Travelling together in one vehicle can simplify coordination and provide a convenient arrangement for family members carrying suitcases and other belongings throughout the journey."
},
{
question: "Can I hire an Innova Crysta from Pune to Rajasthan for a wedding?",
answer: "An Innova Crysta can be arranged for families and guests travelling from Pune to Rajasthan for weddings, receptions, destination functions, and other celebrations. The rental can be planned around the event dates, accommodation locations, passenger count, luggage, and other destinations included in the itinerary."
},
{
question: "Can I carry luggage during a Pune to Rajasthan Innova Crysta trip?",
answer: "Passengers planning a long Rajasthan journey can provide their approximate luggage details while making the rental enquiry. This is especially useful for multi-day trips where travellers may carry several suitcases, personal belongings, and additional items required throughout the road journey."
},
{
question: "Can I include sightseeing in my Pune to Rajasthan Innova Crysta rental?",
answer: "Sightseeing can be discussed as part of the overall Rajasthan travel itinerary. Depending on the planned route, travellers may include attractions such as Amer Fort, City Palace, Lake Pichola, Mehrangarh Fort, or other destinations across Rajasthan while coordinating the journey schedule with Citysky Cabs."
},
{
question: "Can corporate groups rent an Innova Crysta from Pune to Rajasthan?",
answer: "Corporate teams can enquire about an Innova Crysta for business travel, conferences, company tours, industrial visits, professional events, or employee trips in Rajasthan. The vehicle arrangement can be planned around the group's travel dates, meeting locations, accommodation, and required stops."
},
{
question: "Can I book a round-trip Innova Crysta from Pune to Rajasthan?",
answer: "Travellers planning to return to Pune after completing their Rajasthan tour can enquire about a round-trip rental. Sharing the complete travel period, return date, cities to be visited, passenger count, and approximate itinerary helps Citysky Cabs understand the requirements for the extended journey."
},
{
question: "How can I book Pune to Rajasthan Innova Crysta Rental with Citysky Cabs?",
answer: "To enquire about an Innova Crysta rental, provide your Pune pickup location, Rajasthan destinations, travel dates, passenger count, luggage details, preferred departure time, and complete or approximate tour plan. Citysky Cabs can coordinate the vehicle arrangement around your long-distance Rajasthan itinerary."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Dinesh Rathod",
feedback:
"Our family planned a multi-day Rajasthan road trip from Pune covering Jaipur, Udaipur and Jodhpur. We wanted one vehicle because there were several of us travelling with luggage. The Innova Crysta rental through Citysky Cabs made the group travel easier to coordinate, and we were able to share our itinerary before the journey.",
rating: 5
},
{
id: 2,
name: "Miss. Shweta Patil",
feedback:
"We travelled from Pune to Rajasthan for a wedding and added a few sightseeing days around the function. Since the trip involved luggage and multiple locations, an Innova Crysta was convenient for our group. Citysky Cabs discussed the travel dates and itinerary with us and arranged the cab around our overall plan.",
rating: 5
}
];








































    const Images = [

    { place: "/images/keyword/1.jpg", text: "Innova Crysta Cab in Pune", link: "innova-crysta-cab-in-pune" },

    { place: "/images/keyword/2.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },

    { place: "/images/keyword/3.jpg", text: "Innova Crysta Cabs / Taxi Booking in Pune", link: "innova-crysta-cabs-taxi-booking-in-pune" },

    { place: "/images/keyword/4.jpg", text: "Pune to Mahabaleshwar Innova Crysta Cab", link: "pune-to-mahabaleshwar-innova-crysta-cab" },

    { place: "/images/keyword/5.jpg", text: "Book Innova Crysta for Outstation From Pune", link: "book-innova-crysta-for-outstation-from-pune" },

    { place: "/images/keyword/6.jpg", text: "Innova Crysta Cabs for Pune Airport", link: "innova-crysta-cabs-for-pune-airport" },

    { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Airport Innova Crysta", link: "pune-to-mumbai-airport-innova-crysta" },

    { place: "/images/keyword/8.jpg", text: "Innova Crysta Cab for Corporate Office", link: "innova-crysta-cab-for-corporate-office" },

    { place: "/images/keyword/9.jpg", text: "Mumbai Airport to Pune Innova Crysta Cabs", link: "mumbai-airport-to-pune-innova-crysta-cabs" },

    { place: "/images/keyword/10.jpg", text: "Pune to Shirdi Innova Crysta", link: "pune-to-shirdi-innova-crysta" },

    { place: "/images/keyword/11.jpg", text: "Pune Aurangabad Innova Crysta Cab Service", link: "pune-aurangabad-innova-crysta-cab-service" },

    { place: "/images/keyword/12.jpg", text: "Pune to Goa Innova Crysta Cab", link: "pune-to-goa-innova-crysta-cab" },

    { place: "/images/keyword/13.jpg", text: "Pune to Bangalore Innova Crysta Cab", link: "pune-to-bangalore-innova-crysta-cab" },

    { place: "/images/keyword/14.jpg", text: "Pune to Hyderabad Innova Crysta Rental Cab", link: "pune-to-hyderabad-innova-crysta-rental-cab" },

    { place: "/images/keyword/15.jpg", text: "Innova Crysta on Rent in Pune", link: "innova-crysta-on-rent-in-pune-2" },

    { place: "/images/keyword/16.jpg", text: "Pune to Lavasa Innova Crysta Cab Booking", link: "pune-to-lavasa-innova-crysta-cab-booking" },

    { place: "/images/keyword/17.jpg", text: "Pune Darshan Innova Crysta Cabs", link: "pune-darshan-innova-crysta-cabs" },

    { place: "/images/keyword/18.jpg", text: "Innova Crysta Cabs in Pune", link: "innova-crysta-cabs-in-pune" },

    { place: "/images/keyword/19.jpg", text: "Innova Car Rental In Pune", link: "innova-car-rental-in-pune" },

    { place: "/images/keyword/20.jpg", text: "Innova Taxi Service in Pune", link: "innova-taxi-service-in-pune" },

    { place: "/images/keyword/21.jpg", text: "Book Innova for Outstation Pune", link: "book-innova-for-outstation-pune" },

    { place: "/images/keyword/22.jpg", text: "Innova Crysta On Rent In Pune", link: "innova-crysta-on-rent-in-pune-3" },

    { place: "/images/keyword/23.jpg", text: "Pune to Mahabaleshwar Panchgani Innova Crysta Cabs", link: "pune-to-mahabaleshwar-panchgani-innova-crysta-cabs" },

    { place: "/images/keyword/24.jpg", text: "Pune to Outstation Innova Crysta Booking", link: "pune-to-outstation-innova-crysta-booking" },

    { place: "/images/keyword/25.jpg", text: "Innova Crysta on Rent in Pune", link: "innova-crysta-on-rent-in-pune-4" },


];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Rajasthan Innova Crysta Rental",
  "image": "https://www.cityskycab.in/assets/images/pune-to-rajasthan-innova-crysta-rental.webp",
  "description": "Pune to Rajasthan Innova Crysta Rental from Citysky Cabs is a comfortable private travel option for families, groups, business travellers and passengers planning a long-distance road journey from Pune to Rajasthan. The service covers Pune to Rajasthan Innova Crysta Cab, taxi, booking, rental, on-rent and hire requirements, along with AC and luxury travel options. A spacious 7-seater Innova Crysta provides comfortable seating and useful luggage space for extended highway journeys, making it suitable for family vacations, Rajasthan tours, wedding travel, business visits and multi-city trips. Customers can choose one-way or round-trip travel depending on their itinerary, with vehicle arrangements planned around pickup location, travel dates, route requirements and passenger needs.",
  "brand": {
    "@type": "Brand",
    "name": "Citysky Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.cityskycab.in/pune-to-rajasthan-innova-crysta-rental"
  }
};








    return (
        <div>

<Helmet>
  <title>
    Pune to Rajasthan Innova Crysta Rental | Pune Rajasthan 7 Seater Crysta for Long Distance Travel | +91 8554819191
  </title>

  <meta
    name="description"
    content="Travel from Pune to Rajasthan in a spacious 7-seater AC Innova Crysta with Citysky Cabs. Suitable for family tours, business trips, weddings, multi-city travel and one-way or return journeys."
  />

  <meta
    name="keywords"
    content="Pune to Rajasthan Innova Crysta Cab, Pune to Rajasthan Innova Crysta Taxi, Pune Rajasthan Innova Crysta Booking, Pune Rajasthan Innova Crysta Rental, Pune to Rajasthan Innova Crysta on Rent, Pune to Rajasthan Innova Crysta Hire, Pune Rajasthan AC Innova Crysta Cab, Pune Rajasthan Luxury Innova Crysta Cab, Pune to Rajasthan 7 Seater Innova Crysta, Pune Rajasthan One Way Innova Crysta Cab, Pune Rajasthan Round Trip Innova Crysta Cab, Pune to Rajasthan Innova Crysta Rental, Pune Rajasthan Innova Crysta Cab Service, Pune Rajasthan Innova Crysta Taxi Service, Pune Rajasthan Outstation Cab, Pune Rajasthan Long Distance Taxi, Pune Rajasthan Family Tour Cab, Pune Rajasthan Road Trip Innova Crysta, Pune Rajasthan Multi City Cab, Pune Rajasthan Premium AC Innova Crysta"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <div className="sisf-banner sis-br-radius mt-3 position-relative">
                <div className="banner-img">
                    <figure>
                      {/* <img
                            src="/images/page-banner.jpg"
                            alt="Mauliwala Travels Urbania and Mini Bus Rental Pune"
                        /> */}
                    </figure>
                </div>

                <div className="sisf-page-title sisf-m sisf-title--standard sisf-alignment--center">
                    <div className="sisf-m-inner container">
                        <div className="sisf-m-content sisf-content-grid">
                            <h1 className="sisf-m-title text-white sis-text-anime-style-3 entry-title">
                                {cardData.keyword}
                            </h1>
                        </div>
                    </div>
                </div>
            </div>














            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/47.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Citysky Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Citysky Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Citysky Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918554819191" className="pc-call">+91 8554819191 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+918459883515" className="pc-call">+91 8459883515 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918459883515
"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918459883515" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@cityskycab.in" className="pc-email">
                                            booking@cityskycab.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Citysky Cabs</strong><br />

                                            Office No,307,3rd Floor,
                                            52, Sinhgad Rd, Wadgaon Budruk,
                                            Narhe, Pune, Maharashtra,India- 411041.






                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetorajsthaninnnova;